import angular from 'angular';
import '../resources/poll';

const module = angular.module('whyline.services.poll', ['whyline.resources.poll', 'ngFileSaver']);

let $translate;
let FileSaver;

class PollService {
  static $inject = ['Poll', '$timeout', 'FileSaver', '$translate'];

  constructor(Poll, $timeout, fileSaverInjected, translationServiceInjected) {
    this.Poll = Poll;
    this.$timeout = $timeout;
    FileSaver = fileSaverInjected;
    $translate = translationServiceInjected;
  }

  GetAnswers(params) {
    return this.Poll.GetAnswers(params);
  }

  GetAnswersExport(params) {
    return this.Poll.GetAnswersExport(params).then((result) => {
      const file = new Blob([result.data], { type: 'text/csv;charset=utf-8' });
      const fileName = `${$translate.instant('text_results')}-${$translate.instant(
        'poll answers',
      )}.csv`;

      return FileSaver.saveAs(file, fileName);
    });
  }
}

module.exports = module.service('PollService', PollService);
